import { IconContext } from '@phosphor-icons/react';
import React from 'react';

const PhosphorIconsProvider: React.FC<React.PropsWithChildren<{}>> = ({
    children,
}) => {
    return (
        <IconContext.Provider
            value={{
                color: 'rgb(var(--color-gray-700))',
                size: 16,
                weight: 'duotone',
                mirrored: false,
            }}
        >
            {children}
        </IconContext.Provider>
    );
};

export default PhosphorIconsProvider;
